export const faqBuyersData = [
  {
    tabHeader: "Posting on the app",
    tabContent: [
      {
        section: "Posting on the app",
        points: [
          {
            point: "How do I make a post?",
            detail:
              "Select the create post icon by clicking the +Post icon at the bottom navigation of the home page. This opens a pop up which allows you to select how you want to post to make post. You can Take/Upload a photo of the item you want to buy, Search web for a photo, describe in detail what you want to buy, or share a voice note with the Pamo customer care, and a post will be created on your behalf.",
          },
          {
            point: "What do I include in my posts?",
            detail: [
              "Product Specification",
              "Condition of item (New, used, or fairly used)",
              "Amount you are willing to pay",
              "Quantity needed",
              "Photos of the item",
              "Delivery location",
              "Additional details may be required depending on the type of item.",
            ],
          },
          {
            point: "Do I always have to be specific in my posts?",
            detail:
              "It is best to be specific about the brand, product, or specifications. In the posting process, this has been made easy by presenting pre-selected buttons you can choose to determine the category and sub-category of your post.",
          },
          {
            point: "Can I make a post anonymously?",
            detail:
              "Yes. To appear anonymous, click on the 'Hide Identity' button at the top right corner when making a post. This way, you appear anonymous on the trade feed.",
          },
          {
            point: "Do I have to attach pictures to my posts?",
            detail:
              "Yes. To do so, you can either select a picture from your phone's photo gallery or choose 'search web for photo' when making a post. Attaching photos helps merchants serve you better.",
          },
          {
            point: "Can I post any item at all?",
            detail: "No. Items that fit the criteria below are not allowed:",
            subpoints: [
              "Contains nudity",
              "Abusive, offensive, or harmful",
              "Contains advertisement",
              "Illegal products",
              "Suspicious or stolen items",
            ],
          },
          {
            point: "Can I make one post for bulk purchases?",
            detail:
              "Yes. You can indicate the quantity of the items needed when making your post. You can also request different items in a single post. This feature is, however, only available for groceries.",
          },
          {
            point: "When can I make a post on Pamo?",
            detail: "Anytime. The app works 24/7.",
          },
          {
            point: "Can I post an item I want to sell?",
            detail:
              "Yes. You can upload such items to your catalogue after you have signed up as a merchant. Merchants who are looking for something to buy are free to post it on the trade feed, but cannot post items for sale on the trade feed.",
          },
          {
            point: "Is there a limit on how many things I can post on Pamo?",
            detail: "No.",
          },
          {
            point: "Does my post expire?",
            detail:
              "No. Your post does not expire, but you can delete your post if you are no longer interested in getting the item.",
          },
          {
            point: "How do I share a post?",
            detail:
              "Tap on the Share icon at the bottom of the post. This allows you to share the post through the available channels on your phone.",
          },
          {
            point: "How do I save a post?",
            detail:
              "Tap on the Save icon at the bottom of the post. You must sign up to save a post.",
          },
          {
            point: "How do I edit a post?",
            detail:
              "Click the meatball menu (three horizontal dots) on your post and select Edit. You will be given an edit page with the current details of the post so you can make the required changes. You can only edit your post before you have received any offers.",
          },
          {
            point: "Can I repost another post I've seen on the app?",
            detail:
              "Click the meatball menu (three horizontal dots) on a post and select Repost. You will be given a page with the current details of the post so you can make changes to the amount, quantity, condition, delivery location, and delivery time. You can repost your post or another person's post.",
          },
          {
            point: "How do I report a post?",
            detail:
              "Click the meatball menu (three horizontal dots) on a post and select Report. You will be asked to choose the reason for reporting the post. You must sign up to report a post.",
          },
          {
            point: "How do I delete a post?",
            detail:
              "Click the meatball menu (three horizontal dots) on your post and select Delete. A post can be deleted if no deal has been reached on it. You can only delete your post.",
          },
        ],
      },
    ],
  },
  {
    tabHeader: "Posting via Voice Note",
    tabContent: [
      {
        point: "Can I make a post using a voice message?",
        detail:
          "Yes, you can record a voice description of what you want to buy into the app. It can be 60 seconds or less.",
      },
      {
        point: "How do I go about creating a post by voice note?",
        detail:
          'Go to "+Post" on the bottom bar in the app to send Pamo a voice message to create a post for you. You can also go to "Chats" on the bottom bar in the app and click the purple contact centre emoji to send Pamo a voice message to create a post on your behalf. The system then converts your voice message to text and creates a tradefeed post on your behalf using your user ID. Your post will appear anonymous on the trade feed.',
      },
    ],
  },
  {
    tabHeader: "Making payments using your Trade card",
    tabContent: [
      {
        point: "What is the Pamo trade card?",
        detail:
          "It is your personalised, virtual shopping card on Pamo. Buyers use the funds on their trade card to negotiate with a merchant, as well as make payments. Merchants receive payment for the items they have delivered on their trade card. You can top up or withdraw from your trade card at any time.",
      },
      {
        section: "something here",
        points: [
          {
            point: "What are the balances below my trade card?",
            detail: [
              "There are two balances: your total balance and your available balance.",
              "Total balance is the total amount of funds on your trade card at any given time. When you complete a purchase and confirm delivery of items, the total balance will be reduced by the amount involved in the purchase.",
              "Available balance: These are funds that are not locked to any deal or negotiation and are available to be withdrawn or used for a negotiation or deal. The available balance will always be less than or equal to the total balance.",
              "The difference between your total balance and available balance is funds that are currently locked to a pending transaction.",
            ],
          },
        ],
      },
      {
        point: "Can I unlock my funds?",
        detail:
          "Yes. You can only unlock funds from your live posts. On your Profile, click the post(s) with a padlock in the top right corner. Any live post with a padlock has locked funds. To unlock the funds, long-press the post and choose Unlock funds. Your funds will instantly be released, and your available balance will increase.",
      },
      {
        point: "How do I add a payment type to my account?",
        detail:
          "Go to Profile, select Add Payment Type (below Trade card), and follow the prompts. The basic payment options are card, mobile money, and bank account. These may vary depending on your country. On your first deal, you will be required to add a payment type to top up your card if you have not already done so.",
      },
      {
        point: "How do I top up my Pamo trade card?",
        detail:
          'Go to "Top Up" below your trade card. Select any of the payment options you have added to your Pamo account. You will need to provide the amount you want to top up with, and follow the approval process for debiting your card or mobile money trade card. The amount provided is debited from your card or mobile money trade card and credited to your Pamo trade card.',
      },
      {
        point: "Can I make a payment for a post with my mobile money or card?",
        detail:
          "No. You can only make a payment for a post with the available balance on your trade card. However, you can top up or fund your trade card using your mobile money tradecard or card.",
      },
      {
        point: "Can I withdraw funds from my trade card?",
        detail:
          "Yes, you can withdraw funds from your available balance on your Pamo trade card to your mobile money tradecard or bank account at any time. Withdrawal is free.",
      },
      {
        point: "When do I pay for an item?",
        detail:
          "The amount you are willing to pay for an item is withheld from your available balance once you begin negotiations. The withheld amount remains part of your total balance until you confirm delivery, after which it is released to the merchant.",
      },
      {
        point: "Are there charges for using Pamo?",
        detail:
          "We do not charge you for using the app. Your bank or Mobile money provider may, however, charge standard fees for debit and credit, from and to cards, mobile wallets, bank accounts, etc.",
      },
    ],
  },
  {
    tabHeader: "Viewing offers on the trade feed",
    tabContent: [
      {
        point: "What is a trade feed?",
        detail:
          "It is the general view or board of the Pamo App where you find the list of posts made by buyers.",
      },
      {
        point: "How do I view offers made to my post?",
        detail:
          "You can view offers made to your posts by checking your chats in the chatroom to view all offers you've received.",
      },
      {
        point: "Why can't I see an offer I previously viewed?",
        detail:
          "The offer may have been deleted by the merchant because of entry errors, or the offer may have expired based on the expiry duration set by the merchant.",
      },
    ],
  },
  {
    tabHeader: "Getting to a Deal",
    tabContent: [
      {
        point: "How do I negotiate with a merchant?",
        detail:
          "You can negotiate with the merchant via a chat with them in the chat room.",
      },
      {
        point: "How do I make a deal with a merchant?",
        detail:
          "Tap on the merchant's response to you. The options available are accept, decline, or chat with the merchant to negotiate the price. A deal is made once the merchant agrees to your offer. You can only make a deal if your Pamo trade card is funded with the amount you included in your trade post.",
      },
    ],
  },
  {
    tabHeader: "Delivery",
    tabContent: [
      {
        point: "What are the delivery costs?",
        detail:
          "Your delivery cost will depend on your preferred delivery option as well as the distance to cover to get your delivery to you. Kindly refer to the app for actual costs.",
      },
      {
        point: "What are the delivery options?",
        detail: "Deliveries are made using either motorbikes, vans, or trucks.",
      },
      {
        point: "What is the expected arrival time of my item?",
        detail:
          "24 hours for items delivered via motorbikes. Items that may require other forms of transportation may take longer.",
      },
      {
        point: "How do I confirm delivery?",
        detail:
          "After a deal has been reached successfully, you will be given options in the chat room to confirm if you have received the correct items ordered or not.",
      },
    ],
  },
  {
    tabHeader: "Warranty",
    tabContent: [
      {
        point: "Is there a warranty on items I purchase?",
        detail:
          "Pamo does not provide a warranty on items purchased. Some merchants, however, may provide this as part of their offering. What Pamo provides is a guarantee that the funds a buyer makes available for a purchase are held till the merchant delivers the correct items on time, after which the held funds are released to the merchant.",
      },
      {
        point: "What happens if the merchant is unable to deliver?",
        detail:
          "The merchant can cancel delivery in your chat room if they are unable to deliver. The post then returns to the trade feed.",
      },
    ],
  },
  {
    tabHeader: "Disputes",
    tabContent: [
      {
        point: "How do I raise a dispute?",
        detail:
          "In your chatroom with the merchant, indicate that items were not delivered at all, or that wrong/defective items were delivered. The merchant can accept or deny your claim. If the merchant accepts your claim, the amount withheld for the deal is released to your available balance. If the merchant denies your claim, a dispute is raised.",
      },
      {
        point: "How is a dispute resolved?",
        detail:
          "A dispute is resolved after both parties agree. The buyer can opt to resolve the dispute in favour of the merchant, and the funds will be released to the merchant's available balance. The merchant can opt to resolve the dispute in favour of the buyer, and the funds will be released to the buyer's available balance. If both parties are unable to agree, they may request a mediator who will resolve the dispute. Requesting a mediator may come at a fee.",
      },
    ],
  },
  {
    tabHeader: "Tracking payments made after a deal",
    tabContent: [
      {
        point: "How do I view my transactions?",
        detail:
          "Tap on the My Pamo icon on the bottom navigation on the home page. Your transactions include your sales, purchases, top-ups, and withdrawals.",
      },
    ],
  },
  {
    tabHeader: "Account management",
    tabContent: [
      {
        point: "How do I view my activities on Pamo?",
        detail:
          "Tap on the My Pamo icon on the bottom navigation. This will display all your activities which include your live posts, pending deliveries, done deals, disputes, and deleted posts.",
      },
      {
        point: "How do I edit my profile?",
        detail:
          "Click the hamburger menu on the top left corner of the profile page. Click your profile image and follow the prompts to change information on your profile.",
      },
      {
        section: "",
        points: [
          {
            point: "How do I delete my account?",
            detail: [
              "To delete your account, tap the hamburger menu icon (☰) at the top left corner of your profile page, go to Settings, then select “Delete Account” – it’s the fourth option.",
              "Once selected, you will receive an email, and your account will be deactivated for 30 days. During this period, you can change your mind and reactivate it by simply logging back in. After 30 days, your account will be permanently deleted and cannot be recovered",
            ],
          },
        ],
      },
    ],
  },
  {
    tabHeader: "Wishlist",
    tabContent: [
      {
        point: "What is Wishlist?",
        detail:
          "Wishlist is a feature that allows users to create a wish list from existing posts on a trade feed. Your selected friends can then contribute to making your wish come true.",
      },
      {
        point: "How do I create a wish?",
        detail:
          "Tap More Options (three dots) next to a post on the trade feed and choose 'Make a wish'",
      },
      {
        point: "Can I have a post and a wish at the same time?",
        detail: "Yes.",
      },
      {
        point: "Who can see a wish?",
        detail:
          "Anyone in your contact list who has logged into the Pamo App can view your wish.",
      },
      {
        point: "Who can contribute to a wish?",
        detail:
          "Anyone in your contact list can contribute to your wish once they have access to it.",
      },
      {
        point:
          "Can a user contribute more than the targeted amount for a wish?",
        detail: "No, a user can not contribute more than the target amount.",
      },
      {
        point: "Can I see the contributions made to my wish?",
        detail:
          "Yes, you can view all contributions and comments made to your wish.",
      },
      {
        point: "Can I delete a wish?",
        detail: "Yes, you can delete a wish.",
      },
      {
        point:
          "What happens to the contributions after I have deleted my wish?",
        detail:
          "The contributions are sent back to the trade cards of the contributors.",
      },
      {
        point: "What happens if a target for my wish is reached?",
        detail: "You are notified and asked to convert the wish to a post.",
      },
      {
        point:
          "Can I convert a wish to a post even when the target amount has not been reached?",
        detail: "Yes.",
      },
    ],
  },
  //   {
  //     tabHeader: "Carting",
  //     tabContent: [
  //       {
  //         point: "What is Carting?",
  //         detail:
  //           "Carting is a feature that allows users to group posts in one cart so they can pay a discounted delivery fee for their items in one delivery.",
  //       },
  //       {
  //         point: "How do I cart?",
  //         detail:
  //           "If you make a post, when another post of yours is yet to be delivered to the same address, Pamo will automatically offer you the opportunity to cart. This means that both deliveries can be made together at a lower cost instead of two separate delivery costs.",
  //       },
  //       {
  //         point: "How many items can a user put in one cart?",
  //         detail: "A cart is allowed to have a maximum of 5 items.",
  //       },
  //       {
  //         point: "How long has the cart been open?",
  //         detail:
  //           "Once the cart is created, it is open until midnight of the same day. No new items can be added once it's closed.",
  //       },
  //       {
  //         point: "Can a user have multiple carts?",
  //         detail:
  //           "Yes. A user can have multiple carts. However, only one cart can be opened at a time.",
  //       },
  //       {
  //         point: "Can a user track their items after a deal has been made?",
  //         detail:
  //           "Yes. A user can track the status of their item from their list of pending deliveries.",
  //       },
  //       {
  //         point: "Can I select multiple products when posting under groceries?",
  //         detail:
  //           "Yes, you can select multiple products before adding the specifications for each selection.",
  //       },
  //     ],
  //   },
  {
    tabHeader: "The Store",
    tabContent: [
      {
        point: "What is the Store?",
        detail:
          "The store is a feature that allows you to browse through various products being sold by our large network of merchants. You can browse through the pages, visit the profile of a merchant you like, view hot deals, popular brands, and amazing discounts, all on the store.",
      },
      {
        point: "What is the deal of the day?",
        detail:
          "For a short period, the deal of the day allows you to get a super discount on the item of the day. Take advantage of this amazing offer by committing to buying before the deal expires. The deals change by day.",
      },
      {
        point: "Who can take part in the deal of the day?",
        detail: "The deal of the day is open to all app users.",
      },
      {
        point: "How long is the deal of the day set for?",
        detail: "The deal of the day will be open for a 24-hour window.",
      },
      {
        point: "Why do you have such good discounts? Is this legit?",
        detail:
          "We have partnered with some amazing brands to offer breathtaking deals to delight our cherished customers. All deals are verified by our in-house team before being uploaded to the app.",
      },
      {
        point: "What are Popular brands?",
        detail:
          "These are item suggestions from merchant inventories or popular market trends favoured by other Pamo buyers.",
      },
      {
        point: "How can I keep track of a merchant whose products I like?",
        detail:
          "To do so, you can follow a merchant you like or add them to your favourites. Doing so allows you to be notified when the merchant adds new items to their catalogue. You can also enter their shop name into the search bar to find their shop.",
      },
      {
        point: "I'm looking for a product. How do I find it within the store?",
        detail:
          "You can search using the search bar at the top of the store page, where you can search by category or product name. If the item brand is displayed under popular brands, you can also click the relevant brand of the item there to search the list.",
      },
      {
        point:
          "What does the purple banner on the top right-hand side of product images on the store mean?",
        detail:
          "It means that the price of such products has been reduced by the percentage listed in the purple banner. When you click the product image, you'll see both the original price and the reduced price listed under the product",
      },
      {
        section: "how do i buy on the store",
        points: [
          {
            point: "How do I buy from the store on Pamo?",
            detail: [
              " Go to the store and click the image of the product you want to buy.",
              " Read the product details and choose the product specifications you prefer.",
              " Click the 'I want this' button to show your interest in buying the item.",
              " The merchant will then confirm the availability of the item.",
              " When they confirm the item is available, click on 'Buy now', review the confirmation page that is presented before finally completing your order.",
              " Or click 'Send a message' to chat with the merchant to ask questions before finalizing your purchase. You can also post photos or send a voice note via the chat.",
            ],
          },
        ],
      },
      {
        point:
          "What happens if the product I want to buy from the store is not available?",
        detail:
          "You'll have the option to post it so other merchants can make offers to you. To do so, click 'Post it' and follow the prompts.",
      },
      {
        point: "Can I browse through a merchant's other products?",
        detail:
          "Yes. Go to the Store and click 'View Shop' to see a merchant's profile and all products on their shop.",
      },
    ],
  },
  {
    tabHeader: "Rating & review",
    tabContent: [
      {
        point: "What does the merchant rating mean? How is it calculated?",
        detail:
          "Each buyer rates their experience with a merchant. The merchant rating is an average of all the ratings each merchant has received.",
      },
      {
        point: "How can I leave a rating on the app?",
        detail:
          "You can leave a rating for both the product and your experience after purchasing from us. After purchasing from Pamo, you'll be given a short survey where you can rate your experience on delivery, merchant, the product, and your general experience. Ratings are done on a range from 1 - 5, with 5 being the best and 1 the worst. You can also leave comments.",
      },
      {
        point: "What does the product rating mean? How is it calculated?",
        detail:
          "After a buyer makes a purchase, they can leave a rating on the product they bought. The product rating is an average of all the ratings on a particular product. The count of people who have left a rating can also be found in brackets next to the overall product rating.",
      },
      {
        point: "Can I change a rating after I've submitted it?",
        detail: "Yes, you can change a rating after submitting it.",
      },
    ],
  },
  //   {
  //     tabHeader: "Earning rewards & making referrals",
  //     tabContent: [
  //       {
  //         point: "What do I stand to gain from making referrals on the app?",
  //         detail:
  //           "Referrals allow you to gain rewards in the form of points by referring one other person to the Pamo app using a code or a link. Rewards are gained when the person uses the code to sign up.",
  //       },
  //       {
  //         point: "What can I do with my earned rewards?",
  //         detail:
  //           "Your earned rewards will be converted to cash on the trade card, which you can use towards future purchases on the app. You cannot pay it out to any external accounts except for use on the trade card.",
  //       },
  //       {
  //         point:
  //           "What's the criteria for redeeming my rewards? What else do I need to know about rewards?",
  //         detail:
  //           "Points earned can only be redeemed when a customer has done a top-up of their Trade Card before. Remember to use your rewards in time before they expire. Don't worry, we'll send you reminders before the expiry date.",
  //       },
  //       {
  //         point: "What is the validity period for a referral code?",
  //         detail:
  //           "All referral or promo codes sent to another person have a validity period of up to 30 days. Once the person inputs the code, they have 5 days to use it as a discount on the purchase of an item.",
  //       },
  //     ],
  //   },
];
